import React from "react";
import { useIntl } from "react-intl";
import { LatLngExpression } from "leaflet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapPin, faPhone } from "@fortawesome/free-solid-svg-icons";
import { main } from "./translations";
import { FacebookIcone, InstagramIcone, LinkedinIcone, WhattsappIcone } from "../../components/icones/icones";
import { ContactForm } from "../../components/forms/forms";
import { MapContainer, MapHomeMarker } from "../../bundles/map-implement";
import "./contact.scss";
import Image_1 from "../../../assets/img/rene-jean-paul-berclaz-ski-montana.png";
import Red_arrow from "../../../assets/svg/fleche-rouge-photo.svg";

const Contact = () => {

    const intl = useIntl();
    const position = [ 46.31276174491367, 7.483991126029801 ] as LatLngExpression;

    return(
        <>
            <hgroup className="page-title">
                <h1>
                    {intl.formatMessage(main.title,{s: (chunks:React.ReactNode) => <em>{chunks}</em>})}<br/>
                </h1>
            </hgroup>
            <section className="basic-50-50 contact">
                <div>
                    <h2>
                        {intl.formatMessage(main.form_title,{s: (chunks:React.ReactNode) => <span>{chunks}</span>})}<br/>
                    </h2>
                    <ContactForm/>
                </div>
                <div>
                    <div>
                            <h3>
                                {intl.formatMessage(main.subtitle_1,{s: (chunks:React.ReactNode) => <span>{chunks}</span>})}<br/>
                            </h3>
                            <address>
                                <a href="tel:+41 27 481 43 43">
                                    <FontAwesomeIcon className="footer-icone" width={16} height={16} icon={faPhone}/>
                                    +41 27 481 43 43
                                </a>
                                <a href="https://maps.app.goo.gl/FWpuuSnaGZ6ZF94Z9" target="_blank">
                                    <FontAwesomeIcon className="footer-icone" width={16} height={16} icon={faMapPin}/>
                                    Avenue de la gare 19<br/>
                                    Crans-Montana 3963
                                </a>
                            </address>
                            <div className="social-network">
                                <FacebookIcone/>
                                <LinkedinIcone/>
                                <InstagramIcone/>
                                <WhattsappIcone/>
                            </div>
                    </div>
                    <div>
                        <h3>
                            {intl.formatMessage(main.subtitle_2,{s: (chunks:React.ReactNode) => <span>{chunks}</span>})}<br/>
                        </h3>
                        <p>
                            {intl.formatMessage(main.schedule_1,{br: () => <br/>})}<br/>
                            <br/>
                            {intl.formatMessage(main.schedule_2,{br: () => <br/>})}<br/>
                            <br/>
                            {intl.formatMessage(main.schedule_3)}<br/>
                        </p>
                    </div>
                    <img className="floating-img" src={Image_1} alt="Texte alternatif par défaut"/>
                    <div className="floating-text">
                        <Red_arrow/>
                        <span>René et Jean-Paul Berclaz</span>
                    </div>
                </div>
            </section>
            <MapContainer center={position} zoom={17}>
                <MapHomeMarker position={position} />
            </MapContainer>
        </>
    );
};

export default Contact;
